const middlewares: Function[] = [];

export default middlewares;
